<template>
  <div>
    <div class="content">
      <!--分类筛选-->
      <div class="sort-bg">
        <div class="brand-sort-bg">
          <div class="sort-title">{{this.$t('common.Categories')}}：</div>
          <ul>
            <li @click="handelBrandClear()" v-show="showBrand">{{this.brand}}
              <i class="el-icon-close" v-if="this.brand !=='' && this.brand != null"></i><i
                class="el-icon-close" v-else v-show="false"></i></li>
            <li @click="handelToolClear()" v-show="showTool">{{this.tool}}
              <i class="el-icon-close" v-if="this.tool !=='' && this.tool != null"></i><i
                class="el-icon-close" v-else v-show="false"></i></li>
          </ul>
        </div>

        <div class="brand-sort-bg">
          <div class="sort-title">{{this.$t('common.Brands')}}：</div>
          <ul>
            <li @click="handelBrandClear">{{this.$t('common.All')}}</li>
            <li v-for="(item,index) in brandList"
                :key="index"
                :uri="item.uri"
                :class="{hover:brand === (language === 'en' ? item.enName : item.name)}"
                @click="handelBrandHover(language === 'en' ? item.enName : item.name, item.uri,item.type)">
              {{language === 'en' ? item.enName : item.name}}
            </li>
          </ul>
        </div>
        <div class="brand-sort-bg">
          <div class="sort-title">{{this.$t('common.Tools')}}：</div>
          <ul>
            <li @click="handelToolClear">{{this.$t('common.All')}}</li>
            <li v-for="(item,index) in toolList"
                :key="index"
                :uri="item.uri"
                :class="{hover:tool === (language === 'en' ? item.enName : item.name)}"
                @click="handelToolHover(language === 'en' ? item.enName : item.name,item.uri)">
              {{language === 'en' ? item.enName : item.name}}
            </li>
          </ul>
        </div>
      </div>
      <!--新闻列表-->
      <ul class="newslist-bg"
          v-loading="newsLoading"
          element-loading-text="Loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.3)"
         >
        <li v-for="item in newsContent" >
          <div  class="news-content-bg">
            <div class="news-content">
              <h3 class="news-title" @click="contentPage(item.id)">{{item.title}}</h3>
              <p> {{item.description}}</p>
            </div>
            <div class="news-time">
              <span>{{$t('common.Author')}}：{{item.author}}</span>{{item.createTime}}<i>{{$t('common.Views')}}：{{item.hits}}</i>
            </div>
          </div>
          <div v-if='item.thumbnail !== "" && item.thumbnail !=null'>
            <img class="news-img" :src="'http://hdd.mrtlab.com'+item.thumbnail"/>
          </div>
<!--          <div v-else></div>-->
        </li>
      </ul>
      <!--分页-->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="number"
        :page-size="size"
        id="pagination"
        layout="total, prev, pager, next, jumper"
        :total="totalElements">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios'

  export default {
    name: "newsList",
    props: ['url', 'tutorialUri'],
    data() {
      return {
        language: this.$store.state.lang,
        newsLoading:true,
        fullscreenLoading:true,
        newsContent: [],
        totalPages: 0,//总页数
        totalElements: 0, //总条数
        size: 0, //当前页条数
        number: 1, //当前页从1开始
        brandList: [],
        toolList: [],
        brand: '',
        tool: '',
        showBrand: true,
        showTool: true,
        localBrand: '',
        localTool: '',
      }
    },
    created: function () {
      this.PageInit();
      this.getNewsList();
      this.getBrandList();
      this.getToolList();
    },
    methods: {
      // 页面初始化
      PageInit() {
        this.localBrand = this.tutorialUri;
        this.brand= sessionStorage.getItem('tutorialHover');
      },

      //获取品牌筛选项
      getBrandList() {
        let _this = this;
        //获取新闻列表片数据
        axios.get(this.$store.state.apiBasePath + "/classify/2")
          .then(function (res) {
            if (res.data.code === 200) {
              let resData = res.data.data;
              resData.forEach(d => {
                _this.brandList.push(d);
              });
            }else {
              this.$message({
                title: _this.$t('message.Error'),
                message:res.data.msg,
                type: 'error',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },
      // 品牌筛选项高亮
      handelBrandHover(name, uri,) {
        this.brand = name;
        this.showBrand = true;
        this.localBrand = uri;
        this.getNewsList();
        this.$emit('brandHover',this.localBrand);
      },
      // 品牌筛选项清除
      handelBrandClear() {
        this.brand = '';
        this.showBrand = false;
        this.localBrand = '';
        this.getNewsList();
      },
      //获取工具筛选项
      getToolList() {
        let _this = this;
        //获取新闻列表片数据
        axios.get(this.$store.state.apiBasePath + "/classify/3")
          .then(function (res) {
            if (res.data.code === 200) {
              let resData = res.data.data;
              resData.forEach(d => {
                _this.toolList.push(d);
              });
            }
          })
      },
      // 工具筛选项高亮
      handelToolHover(name, uri) {
        this.tool = name;
        this.showTool = true;
        this.localTool = uri;
        this.getNewsList();
      },
      // 工具筛选项清除
      handelToolClear() {
        this.tool = '';
        this.showTool = false;
        this.localTool = '';
        this.getNewsList();
      },

      // 新闻列表数据
      getNewsList(currentPage = 1) {
        let _this = this;
        var type2 = this.localBrand;
        var type3 = this.localTool;
        //获取新闻列表片数据
        console.log(this.$store.state.apiBasePath);
        axios.get(this.$store.state.apiBasePath + "/" + this.url + "/list?page=" + currentPage, {
          params: {
            type2: type2, 
            type3: type3
          }
        }).then(function (res) {
          if (res.data.code === 200) {
            _this.newsLoading=false;
            _this.fullscreenLoading=false;
            let resData = res.data.data;
            _this.newsContent = resData.content;
            _this.hits = resData.hits;

            _this.totalPages = resData.totalPages;
            _this.totalElements = resData.totalElements;
            _this.number = resData.number + 1; //服务器返回数据从0开始，分页组件从1开始，所以要加1
            _this.size = resData.size;
          }
        })
      },

      contentPage(id) {
        // this.$router.push({path: "/contentPage/" + id, query: {url: this.url}})
        //跳转新页面 url: this.url传入对应新闻列表参数
        let routeData = this.$router.resolve({path: "/contentPage/" + id});
        // console.log(routeData);
        //点击跳转新页面
        window.open(routeData.href, '_blank');
      },

      //当前页  currentPage 改变时会触发
      handleCurrentChange: function (currentPage) {
        this.number = currentPage;
        this.getNewsList(currentPage);
      },
    }
  }
</script>

<style scoped lang="less">
  .content {
    width:100%;
    margin: auto auto 15px auto;
  }

  // 条件筛选
  .sort-bg {
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    .brand-sort-bg {
      display: flex;
      align-items: baseline;
      padding: 10px;
      font-size: 14px;
      &:nth-of-type(2) {
        border-top: #ddd 1px dashed;
        border-bottom: #ddd 1px dashed;
      }
    }
    .brand-sort-bg i {
      margin-left: 10px;
    }
    .sort-title {
      color: #666;
      margin-right: 15px;
      width: 80px;
      text-align: right;
    }
    .brand-sort-bg ul {
      display: flex;
      flex-wrap: wrap;
      max-height: 60px;
      overflow-y: auto;
    }
    .brand-sort-bg ul li {
      padding: 5px 15px;
    }
    .brand-sort-bg ul li:hover, .brand-sort-bg ul li.hover {
      color: #e60000;
      cursor: pointer;
    }
  }

  // 文章列表
  .newslist-bg {
    text-align: left;
    margin-bottom: 30px;
    li {
      display: flex;
      text-decoration: none;
      margin: 10px 0;
      border-bottom: #e6e6e6 1px solid;
      background: #fff;
      padding: 10px 0 40px 0;
      justify-content: space-between;
    }
    .news-title {
      margin:10px 0;
      font-size: 20px;
      color: #000;
      transition: all ease 0.3s;

    }
    .news-title:hover {
      color: #009e3b;
      cursor: pointer;
      transition: all ease 0.3s;
    }
    .news-content-bg {
      padding-right: 15px;
    }
    .news-content {
      font-size: 14px;
      line-height: 24px;
      color: #666;
      margin: 10px 0;
    }
    .news-content p {
      margin: 0 15px 0 0;
      overflow: hidden;
    }
    .news-img {
      height: 200px;
      width: 300px;
    }
    .news-time {
      font-size: 14px;
      color: #666;
    }
    .news-time span {
      color: #009688;
      margin-right: 15px;
    }
    .news-time i {
      font-style: normal;
      margin-left: 15px;
      color: #e60000;
    }
  }

  .tag {
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    color: #fff !important;
    margin-right: 0 !important;
    margin-left: 10px;
  }
  .tag-f56f39 {
    background: #f56f39;
  }
  .tag-007cae {
    background: #03A9F4;
  }
  .tag-d4003d {
    background: #d4003d;
  }

  @media screen and (max-width: 1024px) {
    .sort-bg {
      .sort-title {
        width: 15vw;
        margin-right: 0;
      }
      .brand-sort-bg ul {
        flex: 1;
      }
    }
    .newslist-bg {
      .news-content p{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .sort-bg {
      .sort-title {
        line-height: normal;
      }
      .brand-sort-bg {

      }
      .brand-sort-bg ul {
        max-height: max-content;
        overflow-y: auto;
      }
    }
    .newslist-bg {
      padding: 0 10px;
      .news-img {
        height: 100px;
        width: 150px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/newsLists/newsList.vue